import { useState, useEffect, useCallback } from 'react';

const DEFAULT_TIMEOUT = 5000;

export const useExpiringState = <T>(
  timeout: number = DEFAULT_TIMEOUT
): [T | null, (newValue: T) => void] => {
  const [value, setValue] = useState<T | null>(null);
  const [timer, setTimer] = useState<ReturnType<typeof setTimeout> | null>(
    null
  );

  const setExpiringValue = useCallback(
    (newValue: T) => {
      setValue(newValue);
      if (timer) clearTimeout(timer);
      const newTimer = setTimeout(() => setValue(null), timeout);
      setTimer(newTimer);
    },
    [timer, timeout]
  );

  useEffect(
    () => () => {
      if (!timer) return;

      clearTimeout(timer);
    },
    [timer]
  );

  return [value, setExpiringValue];
};

export default useExpiringState;
